export const SUBADMIN_MAX_SUSPENSION_DAYS = 90;
export const SUBADMIN_REVIEW_THRESHOLD_DAYS = 30;
export const MAX_SUPERADMIN_SUSPENSION_DAYS = 36500;

export const SUSPENSION_REASON_CATEGORIES = [
  'COURT_ORDER',
  'USER_REPORTS',
  'BLOCKS_PATTERN',
  'COMMUNITY_STANDARDS',
  'OTHER'
] as const;

export type SuspensionReasonCategory = typeof SUSPENSION_REASON_CATEGORIES[number];

export const SUSPENSION_NOTICE_TEXT = {
  en: {
    title: 'Account Paused',
    temporary: 'Your account is paused temporarily.',
    longTerm: 'Your account is paused for a long period.',
    permanent: 'Your account is paused permanently.',
    startsAt: 'Start date',
    endsAt: 'End date',
    permanentUntil: 'Permanent',
    reference: 'Reference ID',
    reasons: {
      COURT_ORDER: 'Your account has been paused because of allegations or orders from a court.',
      USER_REPORTS: 'Your account has been paused after multiple reports from other users.',
      BLOCKS_PATTERN: 'Your account has been paused because many users blocked this account.',
      COMMUNITY_STANDARDS: 'Your account has been paused for a Community Standards concern.',
      OTHER: 'Your account has been paused for the reason described in the notice.'
    },
    canStill: 'You can still read our policies, submit an appeal, or log out.',
    appeal: 'Appeal this decision',
    appealMessage: 'Tell us why you are appealing (up to 1000 characters).',
    submitAppeal: 'Submit appeal',
    appealSubmitted: 'Your appeal was submitted for review.',
    policies: 'Read policies',
    logout: 'Log out'
  },
  hi: {
    title: 'Account par rok',
    temporary: 'Aapka account kuch samay ke liye roka gaya hai.',
    longTerm: 'Aapka account lambe samay ke liye roka gaya hai.',
    permanent: 'Aapka account sthayi roop se roka gaya hai.',
    startsAt: 'Shuru hone ki tareekh',
    endsAt: 'Khatam hone ki tareekh',
    permanentUntil: 'Sthayi',
    reference: 'Reference ID',
    reasons: {
      COURT_ORDER: 'Court ke aarop ya aadesh ke karan aapka account roka gaya hai.',
      USER_REPORTS: 'Doosre users ki kai reports ke baad aapka account roka gaya hai.',
      BLOCKS_PATTERN: 'Kai users ke is account ko block karne ke karan account roka gaya hai.',
      COMMUNITY_STANDARDS: 'Community Standards se judi samasya ke karan account roka gaya hai.',
      OTHER: 'Notice mein diye gaye karan se aapka account roka gaya hai.'
    },
    canStill: 'Aap policies padh sakte hain, appeal bhej sakte hain, ya logout kar sakte hain.',
    appeal: 'Is faisle ke khilaf appeal karein',
    appealMessage: 'Appeal ka karan likhein (1000 characters tak).',
    submitAppeal: 'Appeal bhejein',
    appealSubmitted: 'Aapki appeal review ke liye bhej di gayi hai.',
    policies: 'Policies padhein',
    logout: 'Logout'
  }
} as const;
